import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const addUserDetail = createAsyncThunk(
  "onBoarding/addUserDetail",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const res = await API.postDataApi(
        "Registration/UpdateEntityDetails",
        data,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);
export const addUserContact = createAsyncThunk(
  "onBoarding/addUserContact",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const res = await API.postDataApi(
        "Registration/UpdateContact",
        data,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);
export const addUserAddress = createAsyncThunk(
  "onBoarding/addUserAddress",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        "Registration/UpdateAddress",
        data,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const getAddressStatus = createAsyncThunk(
  "onBoarding/getAddressStatus",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.getApi(
        `Registration/GetAddressStatus/${data}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "onBoarding/deleteAddress",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.deleteDataApi(
        `Registration/DeleteAddress/${data}`,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const deleteContact = createAsyncThunk(
  "onBoarding/deleteContact",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.deleteDataApi(
        `Registration/DeleteContact/${data}`, // contactId
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const SendEmailMessageChat = createAsyncThunk(
  "Registration/SendEmailMessageChat",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const rsp = await API.postDataApi(
        `Registration/SendEmailMessageChat?entityId=${payload.entityId}`
      );
      return rsp.data;
    } catch (error) {
      //console.log(error);
      throw error;
    }
  }
);


export const addEntityDocuments = createAsyncThunk(
  "onBoarding/addEntityDocuments",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        "Registration/AddDocuments",
        data,
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

export const AddDocumentsandStatus = createAsyncThunk(
  "onBoarding/AddDocumentsandStatus",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.postDataApi(
        "Registration/AddDocumentsandStatus",
        data,
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const updateRegistrationDetail = createAsyncThunk(
  "onBoarding/updateRegistrationDetail",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const res = await API.postDataApi(
        "Registration/UpdateRegistrationDetails",
        data,
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);
export const UpdateRegistrationEmail = createAsyncThunk(
  "onBoarding/UpdateRegistrationEmail",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const res = await API.postDataApi(
        "Registration/UpdateRegistrationEmail",
        data,
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const updateNotificationPrefrence = createAsyncThunk(
  "onBoarding/updateNotificationPrefrence",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const res = await API.postDataApi(
        "Registration/SetEntityPreference",
        data,
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const updateManagerInvite = createAsyncThunk(
  "onBoarding/updateManagerInvite",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();
      const res = await API.postDataApi(
        "Registration/UpdateInviteStatus",
        data,
        token
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const documentFileUpload = createAsyncThunk(
  "onBoarding/documentFileUpload",
  async ({ data }, { getState }) => {
    try {
      const res = await API.postApi(
        "Registration/FileUpload",
        data,
        {},
      );
      return res.data;
    } catch (error) {
      console.log(error)
      throw new Error(error);
      
    }
  }
);

const initialState = {
  loading: false,
  profileOptionsValue: "",
  activityOptionsValue: "",
  entityTypeOptionsValue: "",
  disableFrom: 1,
  currentTab: 0,
  status: "idle",
  contact: {},
  address: {},
  snackbarSeverity: "",
  snackbarOpen: false,
  snackbarMessage: "",
  bannerUri: "",
  profileUri: "",
  addEntityDocumnets: {},
  addressStatus: {},
  deleteAddress: {},
  deleteContact: {},
};
export const onBoardingSlice = createSlice({
  name: "onBoarding",
  initialState,
  reducers: {
    reset: (state) => {
      state = initialState;
    },
    setBannerUri: (state, action) => {
      state.bannerUri = action.payload;
    },
    setProfileUri: (state, action) => {
      state.profileUri = action.payload;
    },
    setProfileOptions: (state, action) => {
      state.profileOptionsValue = action.payload;
    },
    setActivityOptions: (state, action) => {
      state.activityOptionsValue = action.payload;
    },
    setEntityTypeOptions: (state, action) => {
      state.entityTypeOptionsValue = action.payload;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setDisableFrom: (state, action) => {
      state.disableFrom = action.payload;
    },
    setSnackbarSeverity: (state, action) => {
      state.snackbarSeverity = action.payload;
    },
    setSnackbarOpen: (state, action) => {
      state.snackbarOpen = action.payload;
    },
    setSnackbarMessage: (state, action) => {
      state.snackbarMessage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUserDetail.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(addUserDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(addUserDetail.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(addUserContact.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(addUserContact.fulfilled, (state, action) => {
        state.loading = false;
        (state.status = "idle"), (state.contact = action.payload);
      })
      .addCase(addUserContact.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(addUserAddress.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(addUserAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.address = action.payload;
      })
      .addCase(addUserAddress.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(updateRegistrationDetail.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(updateRegistrationDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        // state.address = action.payload
      })
      .addCase(updateRegistrationDetail.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(UpdateRegistrationEmail.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(UpdateRegistrationEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        // state.address = action.payload
      })
      .addCase(UpdateRegistrationEmail.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(updateNotificationPrefrence.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(updateNotificationPrefrence.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        // state.address = action.payload
      })
      .addCase(updateNotificationPrefrence.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(SendEmailMessageChat.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(SendEmailMessageChat.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(SendEmailMessageChat.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(updateManagerInvite.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(updateManagerInvite.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        // state.address = action.payload
      })
      .addCase(updateManagerInvite.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(documentFileUpload.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(documentFileUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        // state.address = action.payload
      })
      .addCase(documentFileUpload.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(addEntityDocuments.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(addEntityDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.addEntityDocumnets = action.payload;
      })
      .addCase(addEntityDocuments.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(AddDocumentsandStatus.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(AddDocumentsandStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.addEntityDocumnets = action.payload;
      })
      .addCase(AddDocumentsandStatus.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(getAddressStatus.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getAddressStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.addressStatus = action.payload;
      })
      .addCase(getAddressStatus.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(deleteAddress.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.deleteAddress = action.payload;
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      })
      .addCase(deleteContact.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.deleteAddress = action.payload;
      })
      .addCase(deleteContact.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
      });
  },
});

export const {
  setCurrentTab,
  setProfileOptions,
  setActivityOptions,
  setDisableFrom,
  setEntityTypeOptions,
  setSnackbarSeverity,
  setSnackbarOpen,
  setSnackbarMessage,
  setBannerUri,
  setProfileUri,
} = onBoardingSlice.actions;
export default onBoardingSlice.reducer;
